'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationNotes', ['$scope', '$rootScope', function ($scope, $rootScope) {
        $scope.resetInvestigation();

        $scope.link = {
            state: 'internal.licensing.investigation.note',
            params: [
                {
                    name: 'investigationNoteID',
                    field: 'id'
                },
                {
                    name: 'investigation_note',
                    field: ''
                }
            ]
        }

        $scope.columns = [
            {
                label: 'Note',
                field: 'note_display',
                type: 'ckeditor'
            },
            {
                label: 'Created On',
                field: 'createdon',
                type: 'date'
            },
            {
                label: 'Created By',
                field: 'createdby'
            }
        ];

        $scope.filters = [
            {
                name: 'Users',
                field: 'entered_by',
                options: [
                    { id: null, name: 'All Users' },
                    { id: $rootScope.userAccount.id, name: 'My Notes' }
                ],
                value: null,
                showBlank: false
            },
            {
                name: 'Date',
                field: 'createdon',
                type: 'days',
                options: [
                    { id: 0, name: 'Today' },
                    { id: 1, name: 'Yesterday' },
                    { id: 7, name: 'Last 7 Days' },
                    { id: 30, name: 'Last 30 Days' },
                    { id: 90, name: 'Last 90 Days' }
                ]
            }
        ]
    }])
;